
<template>
<div>
    <div v-if="type=='2'" class="item" :class="[courseIndex==index?'activeMe':'']" :style="{'animation':(index==courseIndex?'upMove 5s infinite':'downMove 5s infinite') }" @mouseover="tapMouseOverP(index)" @mouseleave="tapMouseLeaveP(index)">
        <div class="img">
            <img :src="item.pic" />
            <div class="itext" v-if="courseIndex==index"><span class="iconfont icon-a-7_weikaishi"></span>继续学习</div>
        </div>                
        <div class="p24">       
        <div class="name">
          <span class="icon" v-if="item.WH_ClassType=='1'">视频</span>
          <span class="icon" v-if="item.WH_ClassType=='2'">直播</span>
          <span class="icon" v-if="item.WH_ClassType=='3'">直播</span>
          {{item.title}}</div>
          <div class="f14 c9" style="height:58px" v-if="item.WH_ClassType =='1'">主讲老师：{{item.attr1}}</div>
          <div  v-if="item.WH_ClassType =='2'||item.WH_ClassType =='3'">
            <div class="f14 c9" >主讲老师：{{item.attr1}}</div>
            <div class="f14 c9" v-if="item.attr2 =='直播中'" style="color:#24B291"><i class="iconfont icon-a-11_zhibozhong" style="margin-right:10px"></i>{{item.attr2 }}</div>
            <div class="f14 c9" v-else style="height:29px">学习进度：{{item.attr2 }}</div>
          </div>
        </div>
        <div class="bot" :class="[item.attr2=='直播中'?'boting':'']">
             <div class="date">观看时间：{{$conFun.parseData(item.attr3)}}</div>
        </div>
    </div>
     <div v-else class="item" :class="[courseIndex==index?'activeMe':'']" :style="{'animation':(index==courseIndex?'upMove':'downMove') }" @mouseover="tapMouseOverP(index)" @mouseleave="tapMouseLeaveP(index)">
        <div class="img">
            <img :src="item.cmClasscoverpic" />
            <div class="itext" v-if="courseIndex==index"><span class="iconfont icon-a-7_weikaishi"></span>继续学习</div>
        </div>                
        <div class="p24">
          <!-- <div class="name"><span class="icon">音频</span>{{item.cmClassname}}</div> -->
          <div class="name">{{item.cmClassname}}</div>
          <div class="f14 c9">{{item.WH_ClassType}}主讲老师：{{item.teacherName}}</div>
         
          <div v-if="item.learntime>item.totaltime"  class="f14 c9">已学习：100%</div>
          <div v-else class="f14 c9">已学习：{{item.totaltime ? Math.floor((item.learntime / item.totaltime) * 100) : 0 }}%</div>
        </div>
        <div class="bot">
        <div class="progress"><el-progress :percentage="item.totaltime ? (100 * item.learntime) / item.totaltime : 0"  :show-text="showText" :stroke-width="strokeWidth"></el-progress></div>
        <div class="min">{{item.totaltime?$conFun.parseMin(item.totaltime):'00:00'}}</div>
        </div>
    </div>
</div>
</template>
<script>
export default {
     props:{
        index:'',
        item:'',
        type:''
      },
  data() {     
    return {       
        courseIndex:'-1',      
        strokeWidth:8,
        showText:false
    }
  },
  methods: {    
    tapMouseOverP(index){
       this.courseIndex = index
    },
     tapMouseLeaveP(index){
       this.courseIndex = '-1'
    }  
  }
}
</script>


// WEBPACK FOOTER //
// src/components/ClassItem.vue